import Main from '@/pc/views/Main'
import Index from '@/pc/views/Index'

export default ({
  defaultRoutes: [
    {
      path: '/pc/',
      name: 'Main',
      component: Main,
      children: [
        // 首頁
        { path: '/index', component: Index, name: 'index', id: 'INDEX-1' },
        // JEWELRY- EARRINGS
        { path: '/Earrings', component: () => import(/* webpackChunkName: "Earrings" */ '@/pc/views/Earrings'), name: 'EARRINGS', id: 'JEWELRY-1' },
        // JEWELRY- NECKLACES
        { path: '#', component: () => import(/* webpackChunkName: "Earrings" */ '@/pc/views/Necklaces'), name: 'NECKLACES', id: 'JEWELRY-2' },
        // JEWELRY- RINGS
        { path: '/index', component: () => import(/* webpackChunkName: "Earrings" */ '@/pc/views/Rings'), name: 'RINGS', id: 'JEWELRY-3' },
        // JEWELRY- BRACELETS
        { path: '/Bracelets', component: () => import(/* webpackChunkName: "Bracelets" */ '@/pc/views/Bracelets'), name: 'BRACELETS', id: 'JEWELRY-4' },
        // COLLECTIONS- PACIFIC
        { path: '/Pacific', component: () => import(/* webpackChunkName: "Pacific" */ '@/pc/views/Pacific'), name: 'PACIFIC', id: 'COLLECTIONS-1' },
        // COLLECTIONS- CRYSTAL
        { path: '/Crystal', component: () => import(/* webpackChunkName: "Crystal" */ '@/pc/views/Crystal'), name: 'CRYSTAL', id: 'COLLECTIONS-2' },
        // COLLECTIONS- BLUE
        { path: '/Blue', component: () => import(/* webpackChunkName: "Blue" */ '@/pc/views/Blue'), name: 'BLUE', id: 'COLLECTIONS-3' },
        // COLLECTIONS- JELLYFISH
        { path: '/Jellyfish', component: () => import(/* webpackChunkName: "Jellyfish" */ '@/pc/views/Jellyfish'), name: 'JELLYFISH', id: 'COLLECTIONS-4' },
        // BESPOKE
        { path: '/Bespoke', component: () => import(/* webpackChunkName: "Bespoke" */ '@/pc/views/Bespoke'), name: 'BESPOKE', id: 'BESPOKE-1' },
        // ABOUT
        { path: '/About', component: () => import(/* webpackChunkName: "About" */ '@/pc/views/About'), name: 'ABOUT', id: 'ABOUT-1' },
        // STORE
        { path: '/Store', component: () => import(/* webpackChunkName: "Store" */ '@/pc/views/Store'), name: 'STORE', id: 'STORE-1' },
        // Product detail
        { path: '/ProductDetail', component: () => import(/* webpackChunkName: "ProductDetail" */ '@/pc/views/ProductDetail'), name: 'ProductDetail', id: 'Product_detail' }
      ]
    }
  ]
})
